export default {
  'collectPoint.title': 'สะสมแต้ม',
  'collectPoint.success': 'สะสมแต้มสำเร็จ',
  'collectPoint.obtained': 'ได้รับแล้ว',
  'collectPoint.point': 'แต้ม',
  'collectPoint.enter_amount': 'กรุณากรอกจำนวนเงินธุรกรรม',
  'collectPoint.enter_point': 'กรุณากรอกจำนวนแต้ม',
  'collectPoint.next_step': 'ถัดไป',
  'collectPoint.warning.NOT_REACH_THRESHOLD':
    'ยังไม่ถึงเกณฑ์การสะสมแต้ม จะเพิ่มเฉพาะบันทึกธุรกรรมเท่านั้น',
  'collectPoint.error.LOYALTY_CARD_NOT_ENABLED': 'กิจกรรมสะสมแต้มยังไม่ได้เปิดใช้งาน',
  'collectPoint.error.LOYALTY_CARD_NOT_FOUND': 'ข้อมูลกิจกรรมสะสมแต้มผิดพลาด',
  'collectPoint.error.SHOP_NOT_FOUND': 'ข้อมูลร้านค้าผิดพลาด',
  'collectPoint.error.FLEXIBLE_DEDUCTION_NOT_ENABLED': 'กิจกรรมนี้ไม่อนุญาตให้หักแต้ม',
  'collectPoint.error.SEND_RULE_NOT_FLEXIBLE_SEND': 'ข้อมูลการส่งผิดพลาด',
  'collectPoint.error.NOT_ENOUGH_POINT_FOR_DEDUCT': 'แต้มไม่เพียงพอสำหรับการหัก',
  'collectPoint.error.PARTIAL_SEND_POINT_FAILED': 'การมอบแต้มให้สมาชิกบางส่วนล้มเหลว',
  'collectPoint.error.PARTIAL_DEDUCT_POINT_FAILED': 'การหักแต้มจากสมาชิกบางส่วนล้มเหลว',
  'collectPoint.error.LOYALTY_CARD_SHOP_ERROR': 'ร้านค้าไม่ตรงกับร้านค้าที่กำหนดในบัตรสะสมแต้ม',
  'collectPoint.error.ACCOUNT_SHOP_NOT_ELIGIBLE':
    'ร้านค้าที่บัญชีผู้ใช้งานสังกัดไม่ตรงกับร้านค้าที่กำหนดในบัตรสะสมแต้ม',
  'collectPoint.error.VALIDATE_SEND_POINTS_LIMIT_IN_DAYS_FAILED': 'เกินขีดจำกัดการมอบแต้มต่อวัน',
  'collectPoint.error.AMOUNT_TO_MPS_CARD_POINT_FAILED': 'มอบแต้มล้มเหลว',
  'collectPoint.error.PARAMETERS_ERROR': 'ข้อมูลผิดพลาด',
  'collectPoint.error.MEMBER_PHONE_NOT_FOUND': 'ไม่พบหมายเลขโทรศัพท์',
  'collectPoint.error.MEMBER_NOT_FULL': 'ไม่ใช่สมาชิกเต็มรูปแบบ',
  'collectPoint.error.INTERNAL_SERVER_ERROR': 'เกิดข้อผิดพลาด กรุณาลองใหม่ภายหลัง',
} as Record<string, string>;
